module.exports = __webpack_public_path__ + "static/media/history-background.b5c49d4b.png";